import { render } from "./SelectAndGo.vue?vue&type=template&id=62318726"
import script from "./SelectAndGo.vue?vue&type=script&lang=js"
export * from "./SelectAndGo.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__